import { DocumentoArrecadacaoRetificacaoBase1TO } from "src/app/pagamento/models/documento-arrecadacao-retificacao-base1-to";

export const DOCUMENTO_ARRECADACAO_CNPJ_SIMPLIFICADA_MOCK: DocumentoArrecadacaoRetificacaoBase1TO = {
  numeroRegistro: "3800091914", 
  numeroDocumento: "10100106830258087", 
  ni: "12229753000152", 
  dataArrecadacao: "2020-06-30", 
  dataVencimento: "2020-05-29", 
  periodoApuracao: "2020-05-29", 
  referencia: null, 
  processo: null, 
  idCEF: null, 
  vrba: null, 
  vrbaPercentual: null, 
  codigoBanco: "001", 
  codigoAgencia: "1451", 
  codigoReceita01: "4737", 
  codigoReceita02: "4737", 
  codigoReceita03: null, 
  codigoExtensaoReceita01: null, 
  valorReceita01: 539.57, 
  valorReceita02: 288.62, 
  valorReceita03: null, 
  valorTotal: 828.19, 
  tipoDocumento: { 
    codigo: 4, 
    descricao: "DARF" 
  }, 
  situacaoDocumento: { 
    codigo: 1, 
    descricao: "Original" 
  }, 
  tiicCd: null, 
  idVersao: "1593672729000", 
  isDocumentoNumerado: false, 
  isNiInvalido: false, 
  isCancelaDocAlocPaex: false, 
  isAlteraPABase2: null, 
  isAlteradoDocumentoAlocado: null, 
  processoAlteracao: null, 
  origemErro: null, 
  desmembramentos: null 
};
